import { useMutation, useQueryClient } from "@tanstack/react-query";
import { stornoRequest } from "@/requests/request/storno";
import { handleApiError } from "@/utils/error";
import { ReactQueryKeys } from "@/constants/common";

export const useStornoRequestMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: stornoRequest,
    onError: e => handleApiError(e),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ReactQueryKeys.getContract() });
    },
  });
};
